import type { Filter, FilterDataOption, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { isBeachHoliday } from '@/app/common/filters/groups/isBeachHoliday.ts';
import { type TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { SimpleOptionCreate } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { simpleOptionCreator } from '@/app/common/filters/groups/filterGroupsUtils.ts';

const createBeachTypeOptions = (simpleOptionCreate: SimpleOptionCreate): FilterDataOption[] => [
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.beach_type.white_sand', value: '1' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.beach_type.sand', value: '2' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.beach_type.pebbles', value: '3' }),
];

type CreateBeachTypeFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createBeachTypeFilters = ({ searchParams, translationDictionary }: CreateBeachTypeFilters): Filter[] => {
  const showBeachTypeFilter = isBeachHoliday(searchParams);
  const selectedValues = searchParams[URLParameters.BEACH_TYPE]?.split(',') || [];

  const simpleOptionCreate = simpleOptionCreator({ selectedValues, translationDictionary });

  const beachTypeFilter: Filter | undefined = showBeachTypeFilter
    ? {
        name: FILTER_NAME.BEACH_TYPE,
        type: FILTER_TYPE.MULTI_SELECT,
        data: {
          options: createBeachTypeOptions(simpleOptionCreate),
        } as FilterDataMultiSelect,
      }
    : undefined;

  return [...[beachTypeFilter]].filter((f) => !!f);
};
